import { Injectable } from '@angular/core';
import { SepoInteractionEnum, SepoInteractions, ServicePointFeatures } from '@deprecated/api-interfaces';
import { Observable } from 'rxjs';
import { InteractionRepository } from '../repositories/interaction.repository';
import { TenantConfigService } from './tenant-config.service';

@Injectable({
  providedIn: 'root',
})
export class InteractionService {
  public static readonly featureEvents = new Map<ServicePointFeatures, SepoInteractionEnum>([
    [ServicePointFeatures.WARRANTY_EXTENSION, SepoInteractionEnum.EXTENDED_WARRANTY],
    [ServicePointFeatures.TUBE_SETTINGS_TILE, SepoInteractionEnum.TUBE_SETTINGS],
    [ServicePointFeatures.VISIT_E_SHOP_TILE, SepoInteractionEnum.VISIT_E_SHOP_TILE],
    [ServicePointFeatures.VISIT_SHOP_LINK, SepoInteractionEnum.VISIT_E_SHOP_LINK],
    [ServicePointFeatures.MARKETING_TILE, SepoInteractionEnum.MARKETING_TILE_LINK],
    [ServicePointFeatures.SERVICES_TILE, SepoInteractionEnum.SERVICES_TILE],
    [ServicePointFeatures.SERVICES_FORM, SepoInteractionEnum.SERVICES_FORM],
  ]);

  constructor(
    private tenantConfigService: TenantConfigService,
    private interactionRepository: InteractionRepository,
  ) {}

  public createInteractions(sepoInteraction: SepoInteractions): Observable<SepoInteractions> {
    return this.interactionRepository.createSepoInteractionsData(sepoInteraction);
  }

  public checkFeatureEvent(feature: ServicePointFeatures, deviceId?: string, metadata?: { [key: string]: string }, userId?: string): void {
    const event = InteractionService.featureEvents.get(feature);
    const tenantId = this.tenantConfigService.getTenantId();
    if (event) {
      const interactionData: SepoInteractions = {
        deviceId: deviceId || '',
        event,
        id: '',
        createdDate: '',
        createdBy: userId || '',
        tenantId,
        metadata: metadata || {},
      };
      this.createInteractions(interactionData).subscribe();
    }
  }
}
